module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('section', {
    staticClass: "hero is-primary is-medium header-image",
    attrs: {
      "id": "inicio"
    }
  }, [_c('menubar'), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('sobremi'), _vm._v(" "), _c('projects'), _vm._v(" "), _c('footerbar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-cta"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('p', {
    staticClass: "title is-2"
  }, [_vm._v("Sobre mí")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f5856b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 19
// module chunks = 0